import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/async'
import Educator from '../../../../models/Educator'

const loadTeacherOptions = ({ valueField, schoolId }) => (value, callback) => {
  Educator
    .where({ with_enrolled_students_for_school_id: schoolId })
    .where({
      name: { match: value },
    })
    .order({ name: 'asc' })
    .all()
    .then((res) => {
      const options = res.data
        .filter(e => e.name.toUpperCase() !== 'STAFF')
        .map((e) => ({ label: e.name, value: e[valueField]}))
      callback([{ label: 'Staff', value: 'staff' }, ...options])
    })
}

const AsyncTeacherSelect = ({ name, selectedValue, valueField, placeholder, schoolId }) => {
  const [option, setOption] = useState(selectedValue)

  const teacherOptions = loadTeacherOptions({ valueField, schoolId: schoolId })

  const changeHandler = (opt) => {
    window.location = `/schools/${schoolId}/class_pictures?teacher_id=${opt.value}`
  }

  return (
    <>
      <AsyncSelect
        cacheOptions
        defaultOptions
        placeholder={placeholder}
        defaultValue={selectedValue}
        name={name}
        loadOptions={teacherOptions}
        onChange={changeHandler}
      />
    </>
  )
}

AsyncTeacherSelect.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.object,
  valueField: PropTypes.string,
  extraFields: PropTypes.array,
  placeholder: PropTypes.string,
}

AsyncTeacherSelect.defaultProps = {
  name: null,
  selectedValue: null,
  valueField: 'name',
  extraFields: [],
  placeholder: 'Search All',
}

export default AsyncTeacherSelect
